export default "__VITE_ASSET__84ff739f__"